export default __webpack_public_path__ + "static/media/09.5705e56f.jpg";